<template>
  <v-content>
    <v-overlay v-if="loadingOverlay === true">
      <div>Loading Page...</div>
    </v-overlay>
    <v-container v-if="igProfile !== null">
      <h1 class="subheading grey--text">@{{igProfile.profileName}}</h1>

      <div>
        <h3>Hashtags:</h3>
        <Dropdown
          :options="searchHashtagList"
          v-on:selected="addHashtag"
          v-on:filter="searchHashtags"
          :disabled="false"
          name="hashtag"
          :maxItem="100"
          placeholder="Please select an option"
        ></Dropdown>
      </div>
      <div>
        <div v-for="hashtag in hashtagList" :key="hashtag._id" class="hashtag_style">
          {{hashtag.hashtag}}
          <span @click="archiveHashtag(hashtag.hashtag)" class="archive_button">x</span>
        </div>
      </div>
    </v-container>
  </v-content>
</template>
<script>
import firebase from "firebase";
import axios from "axios";
import Dropdown from "vue-simple-search-dropdown";
import {
  igProfileReadApi,
  hashtagSourceListApi,
  hashtagSourceAddApi,
  hashtagSourceArchiveApi
} from "@/config/appSettings";
import Numeral from "numeral";
export default {
  components: { Dropdown },
  data: () => ({
    loadingOverlay: true,
    igProfile: null,
    searchHashtagList: [],
    searchKeyword: "",
    hashtagList: []
  }),
  name: "EngagementProfileEdit",
  methods: {
    async loadProfile() {
      try {
        let userToken = firebase.auth().currentUser.uid;
        let loadProfileUrl = `${igProfileReadApi}/?usertoken=${userToken}&instagram=${this.$route.params.profileName}`;
        let igProfile = await axios.get(loadProfileUrl);
        if (igProfile.data.success === true) {
          this.igProfile = igProfile.data.result[0];
          this.loadHashtags();
        }
      } catch (err) {
        console.log("ERROR:", err);
      }
    },
    async searchHashtags(event) {
      try {
        //alert(JSON.stringify(event))

        console.log(event);
        this.searchKeyword = event;
        if (
          this.searchKeyword !== "" &&
          this.searchKeyword !== null &&
          typeof this.searchKeyword !== "undefined"
        ) {
          let searchHashtags = await axios.get(
            `https://www.instagram.com/web/search/topsearch/?context=hashtag&query=${this.searchKeyword}`
          );
          let id = 0;
          this.searchHashtagList = searchHashtags.data.hashtags.map(x => {
            let hashtagInfo = {};
            hashtagInfo.id = x.hashtag.name;
            let mediaString = Numeral(x.hashtag.media_count).format("0.0a");
            if (x.hashtag.media_count > 10000000) {
              mediaString = Numeral(x.hashtag.media_count).format("0a");
            }
            hashtagInfo.name = `${x.hashtag.name} (${mediaString})`;
            hashtagInfo.count = x.hashtag.media_count;
            return hashtagInfo;
          });
          //console.log("HASHTAG LIST", this.searchHashtagList);
        }
        //console.log("KEYWORD FAILED")
      } catch (err) {
        //console.log("THERE WAS AN ERROR:", err)
      }
    },
    async addHashtag(event) {
      console.log("EVENT: ", JSON.stringify(event));

      try {
        this.loadingOverlay = true;
        if (typeof event.id !== "undefined") {
          let newHashtag = {};
          newHashtag.hashtag = event.id;
          newHashtag.instagram = this.igProfile.profileName;
          newHashtag.usertoken = firebase.auth().currentUser.uid;
          newHashtag.type = "engagement";
          let hashtagResult = await axios.post(
            `${hashtagSourceAddApi}`,
            newHashtag
          );
          //console.log("HASHTAG RESULT", hashtagResult);
          this.loadHashtags();
        }
        this.closeLoadingModal()
      } catch (err) {
        console.log("ERROR: ", err);
      }
    },
    async archiveHashtag(hashtag) {
      console.log("EVENT: ", hashtag);

      try {
        this.loadingOverlay = true;
        let archiveHashtag = {};
        archiveHashtag.hashtag = hashtag;
        archiveHashtag.instagram = this.igProfile.profileName;
        archiveHashtag.usertoken = firebase.auth().currentUser.uid;
        archiveHashtag.type = "engagement";
        //console.log("ARCHIVING:", archiveHashtag);
        let hashtagResult = await axios.post(
          `${hashtagSourceArchiveApi}`,
          archiveHashtag
        );
        //console.log("HASHTAG RESULT", hashtagResult);
        this.loadHashtags();
      } catch (err) {
        console.log("ERROR: ", err);
      }
    },
    async loadHashtags() {
      //console.log("SELECTED: ", JSON.stringify(event));
      this.loadingOverlay = true;
      let userToken = firebase.auth().currentUser.uid;
      let activeHashtags = await axios.get(
        `${hashtagSourceListApi}/?usertoken=${userToken}&instagram=${this.igProfile.profileName}`
      );
      //console.log("HERE IS THE ACTIVE HASHTAGS: ", activeHashtags);
      this.hashtagList = activeHashtags.data.result;
      this.closeLoadingModal()
      this.loadingOverlay = false;
    },

    closeLoadingModal() {
      let self = this;

      setTimeout(function() {
        self.loadingOverlay = false;
      }, 1000);
    }
  },
  mounted() {
    this.loadProfile();
    this.closeLoadingModal();
  }
};
</script>

<style scoped>
.hashtag_style {
  float: left;
  padding: 5px;
  margin: 3px;
  border: 1px solid gray;
  border-radius: 5px;
  background-color: beige;
}
.archive_button{
  padding: 5px;
}
.archive_button:hover{
  cursor: pointer;
}
</style>